<template>
  <div>
    <HeaderView />
    <EbookHeroSection />
    <EbookForm id="ebook-form-section" class="ebook-reveal" />
    <EbookDetailsSection class="ebook-reveal" />
    <EbookBenefitsSection class="ebook-reveal" />
    <EbookContentSection class="ebook-reveal" />
    <EbookAboutSection class="ebook-reveal" />
    <EbookCtaSection class="ebook-reveal" />
    <FooterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import HeaderView from '@/components/HeaderView.vue'
import EbookHeroSection from '@/components/EbookHeroSection.vue'
import EbookForm from '@/components/EbookForm.vue'
import EbookDetailsSection from '@/components/EbookDetailsSection.vue'
import EbookBenefitsSection from '@/components/EbookBenefitsSection.vue'
import EbookContentSection from '@/components/EbookContentSection.vue'
import EbookAboutSection from '@/components/EbookAboutSection.vue'
import EbookCtaSection from '@/components/EbookCtaSection.vue'
import FooterView from '@/components/FooterView.vue'

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
  const sections = gsap.utils.toArray<HTMLElement>('.ebook-reveal')
  sections.forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 50,
      duration: 0.9,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  })

  // Recalcular tras cargar imágenes/fuentes
  requestAnimationFrame(() => ScrollTrigger.refresh())
})

onUnmounted(() => {
  ScrollTrigger.getAll().forEach((t) => t.kill())
})
</script>

<style scoped>
.ebook-content {
  padding: 60px 20px;
  background: white;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ebook-content h2 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
}

.ebook-content p {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  max-width: 600px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .ebook-content {
    padding: 40px 15px;
  }

  .ebook-content h2 {
    font-size: 2rem;
  }

  .ebook-content p {
    font-size: 1.1rem;
  }
}
</style>
